var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilanci(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.2968078mm",
    height: "3.7967143mm",
    viewBox: "0 0 5.2968078 3.7967143",
    id: "svg5605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-99.405167,-137.86355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5820",
    transform: "translate(94.234189,91.297104)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 46.698944,
    x: 5.3034782,
    height: 0.92131698,
    width: 5.0318079,
    id: "rect5759",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 0.26499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 48.004128,
    x: 5.3034782,
    height: 0.92131698,
    width: 5.0318079,
    id: "rect5759-8",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 0.26499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 49.309341,
    x: 5.3034782,
    height: 0.92131698,
    width: 5.0318079,
    id: "rect5759-6",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 0.26499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.20375279,
    cy: 47.162556,
    cx: 5.8733959,
    id: "path5791",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.20375279,
    cy: 48.460365,
    cx: 5.8733959,
    id: "path5791-0",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.20375279,
    cy: 49.75819,
    cx: 5.8733959,
    id: "path5791-5",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      strokeWidth: 0.26458332
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilanci);
export default __webpack_public_path__ + "static/media/bilanci.f624195e70c20b28192fe0c3c67b2d49.svg";
export { ForwardRef as ReactComponent };